// Utility to optimize image URLs (supports both Cloudinary and AWS S3)
function getOptimizedUrl(imageUrl, width) {
  if (!imageUrl || typeof imageUrl !== 'string') return imageUrl;
  
  // Check if it's an S3 URL
  if (imageUrl.includes('.s3.') && imageUrl.includes('.amazonaws.com')) {
    // S3 URLs are already optimized (converted to WebP at upload)
    // No additional transformation needed
    return imageUrl;
  }
  
  // Original Cloudinary optimization logic for backward compatibility
  const marker = '/upload/';
  const idx = imageUrl.indexOf(marker);
  if (idx === -1) return imageUrl;

  try {
    const rest = imageUrl.slice(idx + marker.length);
    const nextSlash = rest.indexOf('/');
    const firstSegment = nextSlash === -1 ? rest : rest.slice(0, nextSlash);

    const makeInsert = (existingSeg) => {
      const parts = existingSeg ? existingSeg.split(',').filter(Boolean) : [];
      const hasF = parts.some(p => p.startsWith('f_') || p === 'f_auto');
      const hasQ = parts.some(p => p.startsWith('q_') || p === 'q_auto');
      const hasW = parts.some(p => p.startsWith('w_'));
      if (width && !hasW) parts.unshift(`w_${width}`);
      if (!hasF) parts.push('f_auto');
      if (!hasQ) parts.push('q_auto');
      return parts.join(',');
    };

    // If the first segment is a version like v12345, there's no transform present
    if (/^v\d+$/.test(firstSegment)) {
      const insert = makeInsert('');
      return imageUrl.slice(0, idx + marker.length) + insert + '/' + rest;
    }

    // If there's a transformation segment, merge with it; otherwise insert before the rest
    if (firstSegment.includes('f_') || firstSegment.includes('q_') || firstSegment.includes('w_') || firstSegment.includes(',')) {
      const insert = makeInsert(firstSegment);
      const remainder = nextSlash === -1 ? '' : rest.slice(nextSlash + 1);
      return imageUrl.slice(0, idx + marker.length) + insert + '/' + remainder;
    }

    // No transform and no version segment: insert transformation before the rest
    const insert = makeInsert('');
    return imageUrl.slice(0, idx + marker.length) + insert + '/' + rest;
  } catch (e) {
    return imageUrl;
  }
}

export default getOptimizedUrl;
